<template>
    <div>
        <div class="selector-container" :class="[$mq]" :style="backgroundColor ? { backgroundColor: backgroundColor } : {}" @click="openPopup()">
            <span v-if="selectedOption && selectedOption.v" class="selector-color" :style="{ background: selectedOption.c }" :class="[{ 'no-color': !selectedOption.c }]"> </span>

            <span class="selector-item" :class="[$mq]">
                {{ selectedOption.v ? selectedOption.v : translation('assets.selector_popup.title') }}
            </span>
        </div>

        <div class="popup-container blocking popup-small" v-if="isVisiblePopup">
            <div class="popup">
                <div class="list" :class="{ portrait: isApp || ['portrait'].includes($mq) }">
                    <SearchBar customClass="selector-popup" v-if="options.length >= 6" @on-search="filterOptions" />

                    <div class="item-list clear-value" @click="resetValue({ v: null, c: null })">
                        {{ translation('assets.selector_popup.value-zero') }}
                    </div>

                    <div class="items-list" :class="{ 'mobile-landscape': isApp || ['portrait'].includes($mq) }">
                        <div class="item-list" v-for="option in filteredOptions" :key="option.v" @click="changeValue(option)" :class="[{ selected: selectedOption === option }, { 'non-scroll': options.length < 6 }]">
                            <span class="selector-color" :style="{ background: option.c }" :class="[{ 'no-color': !option.c }]"></span>
                            <span class="selector-item">{{ option.v }}</span>
                        </div>
                    </div>

                    <Button bType="cancel" customClass="selector-popup" :bCallback="closePopup" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SearchBar from '@/components/domain/ui/SearchBar.vue'
import Button from '@/components/domain/ui/Button.vue'
import i18n from '@/i18n'
import { displayPreventDeletePopup } from '@/utils/popups'

export default {
    components: {
        SearchBar,
        Button
    },
    name: 'SelectorPopup',
    props: {
        options: {
            type: Array,
            default() {
                return []
            }
        },
        value: {
            type: undefined,
            default: null
        },
        canClicked: {
            type: undefined,
            default: true
        },
        itemHasActionPlan: {
            type: Boolean,
            default: false
        },
        isActionPlanPage: {
            type: Boolean,
            default: false
        },
        backgroundColor: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            selectedOption: { c: true, v: null },
            isVisiblePopup: false,
            filteredOptions: []
        }
    },
    computed: {
        isAuditItemInActionPlan() {
            return this.itemHasActionPlan && this.isActionPlanPage
        },
        isApp() {
            return this.$store.state.getIsApp
        },
        hasStoredValue() {
            return this.value !== null && this.value !== '' && this.value !== undefined
        }
    },
    methods: {
        openPopup() {
            this.$emit('openSelect')
            if (this.canClicked === true && !this.isAuditItemInActionPlan) {
                // !this.isAuditItemInActionPlan is important to not show the selector popup in the non-conformity audit item in the action plan checklist
                this.isVisiblePopup = true
                this.$store.commit('setSelectPopup', true)
            }
        },
        reopenPopup() {
            this.load()
            this.isVisiblePopup = true
            this.$store.commit('setSelectPopup', true)
        },
        filterOptions(e) {
            const target = e.target.value
            this.filteredOptions = this.options.filter((option) => option.v.toLowerCase().includes(target.toLowerCase()))
        },
        load() {
            if (this.value) {
                this.selectedOption = this.options.find((option) => option.v == this.value)
            } else {
                this.selectedOption = { c: null, v: null }
            }

            this.filteredOptions = this.options
        },
        changeValue(option) {
            this.isVisiblePopup = false
            this.selectedOption = option

            this.$emit('input', option.v)
            this.$store.commit('setSelectPopup', false)
        },
        async resetValue(option) {
            this.isVisiblePopup = false

            if (this.hasStoredValue && !this.itemHasActionPlan) {
                const confirmed = await displayPreventDeletePopup(this)

                if (!confirmed) {
                    this.isVisiblePopup = true
                    return
                }
            }

            this.selectedOption = option
            this.$emit('reset', option.v)
        },
        closePopup() {
            this.isVisiblePopup = false
            this.filteredOptions = this.options
            this.$store.commit('setSelectPopup', false)
        },
        translation(key) {
            return i18n.t(key)
        },
        isOldDate(date) {
            const today = new Date()
            const dateToCompare = new Date(date)
            return dateToCompare < today
        }
    },
    created() {
        this.load()
    },
    watch: {
        value() {
            this.load()
        },
        isVisiblePopup(newVal) {
            this.$emit('popup-status', newVal)
            if (newVal) {
                window.dispatchEvent(new Event('popup-open'))
            } else {
                window.dispatchEvent(new Event('popup-close'))
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.selector-container {
    width: 100%;
    height: 100%;
    background-color: $color-selector;
    padding: 8px;
    padding-right: 26px;
    position: relative;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    @include border-radius(3px);
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 0.8em;

    &.portrait {
        width: 100%;
        // width: 120px;
    }

    &::after {
        content: '';
        position: absolute;
        top: 50%;
        right: 8px;
        transform: translateY(-50%);
        background: img('down_caret_aaaaaa.svg') no-repeat center;
        background-size: contain;
        width: 10px;
        height: 10px;
    }

    .selector-item {
        white-space-collapse: collapse;
        text-wrap: nowrap;
        min-height: 1.2em;
        color: $color-letter-selector;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;

        &.portrait {
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }

    .selector-color {
        padding: 5px;
        @include border-radius(100%);
        margin-left: 8px;

        // &.no-color {
        //     border: 1px solid $color-selector2;
        //     position: relative;
        // }
    }
}

.list {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    position: relative;

    .selector-cancel-btn {
        width: 100%;
        margin: 0px;
    }

    .item-list {
        padding: 8px;
        display: flex;
        align-items: center;
        gap: 12px;
        cursor: pointer;
        width: 98%;
        margin: 8px 0;
        border: 1px solid $color-neutral-300;
        @include border-radius(4px);
        transition: all 0.3s ease-in-out;

        &.non-scroll {
            width: 100%;
        }

        &:hover {
            background-color: $color-selector;
        }

        &.selected {
            background-color: $color-neutral-200;
        }

        &.clear-value {
            color: $color-letter-selector;
            width: 100%;
            padding-right: 8px;
            font-size: 1.1em;
            padding-left: 38px;
            padding-right: 8px;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            overflow-wrap: anywhere;
        }
    }

    &.portrait {
        .clear-value {
            font-size: 0.8em;
        }
    }

    .items-list {
        margin-top: 2px;
        max-height: 280px;
        overflow-y: auto;
        padding-right: 8px;
        width: 100%;

        &.mobile-landscape {
            max-height: 205px;

            .selector-item {
                font-size: 0.8em;
                min-height: 1.2em;
                color: $color-letter-selector;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
                overflow-wrap: anywhere;
            }
        }

        .selector-color {
            padding: 5px;
            @include border-radius(100%);
            margin-left: 8px;

            &.no-color {
                border: 1px solid $color-selector2;
                position: relative;
            }
        }

        .selector-item {
            font-size: 1.1em;
            min-height: 1.2em;
            color: $color-letter-selector;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
}
</style>
